export const openIdRequestOptions = {
  responseType: 'code',
  scope: '.default openid profile email offline_access',
};
